import "./telemetry"; // FIRST: browser tracing, error handlers, same-origin telemetry (T7, CR-13)
import "@vbltc/ui/styles.css"; // Tailwind v4 + shadcn tokens (one stylesheet, T3)
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { router, queryClient } from "./app/router";
import { ErrorBoundary } from "./app/error-boundary";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<p role="alert">Something went wrong. Reload the page.</p>}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
